import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountsService {
  constructor(private readonly http: HttpClient) {}

  getPendingCounts(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('v1/admin/counts');
  }
}
